export { default } from "./textWithColorMark";
export { getBoolColor } from "./textWithColorMark.utils";
